import { atom } from 'jotai';

export const schoolyearSchoolAtom = atom<
  | {
      schoolyearId: string;
      schoolId: string;
    }
  | undefined
>(undefined);

export const notNullSchoolyearSchoolAtom = atom<{
  schoolyearId: string;
  schoolId: string;
}>(get => {
  const value = get(schoolyearSchoolAtom);
  if (!value) {
    throw new Error('schoolyearSchoolAtom is null');
  }
  return value;
});
